import * as actionTypes from "../constants/ActionTypes";
import initialState from "./initialState";

export default function scopeReducer(state = initialState.scope, action) {
  switch (action.type) {
    case actionTypes.SET_SCOPE: {
      return action.payload || initialState.scope;
    }
    case actionTypes.RESET_SCOPE: {
      return initialState.scope;
    }
    default:
      return state;
  }
}
